import React, { useMemo, useState } from "react";
import Swal from "sweetalert2";
import { submitMutualFundInvestorProfile } from "../../../api/bseApi";

const INITIAL_DATA = {
  data: {
    member: { member_id: "63164" },
    investor: { client_code: "DematUCCTest9" },
    holding_nature: "SI",
    tax_code: "01",
    rdmp_idcw_pay_mode: "02",
    is_client_physical: false,
    is_client_demat: true,
    is_nomination_opted: false,
    comm_mode: "E",
    onboarding: "Z",
    holder: [
      {
        holder_rank: "1",
        occ_code: "02",
        auth_mode: "M",
        is_pan_exempt: false,
        kyc_type: "K",
        person: {
          first_name: "NEELESH",
          last_name: "VERMA",
          dob: "1996-03-11",
          gender: "M",
        },
        contact: [
          {
            contact_number: "9403231688",
            country_code: "91",
            whose_contact_number: "SE",
            email_address: "parth.ashtikar@bseindia.com",
            whose_email_address: "SE",
            contact_type: "PR",
          },
        ],
        identifier: [
          {
            identifier_type: "pan",
            identifier_number: "AVDPV9611N",
          },
        ],
      },
    ],
    comm_addr: {
      address_line_1: "121 RAJESHWAR NGR PHASE 2",
      city: "DEHRADUN",
      state: "UTTARANCHAL",
      postalcode: "248001",
      country: "INDIA",
    },
    bank_account: [
      {
        ifsc_code: "PUNB0469200",
        bank_acc_num: "1234567890123456",
        bank_acc_type: "SB",
        account_owner: "SELF",
      },
    ],
    depository: [
      {
        depository_code: "CDSL",
        dp_id: "12345678",
        client_id: "12345678",
        bank_account: "1234567890123456",
        account_owner: "SELF",
        is_default: true,
      },
    ],
    identifiers: [
      {
        identifier_type: "aof",
        file_name: "",
        file_blob: "",
        file_size: 0,
      },
    ],
  },
};

export default function UccV2DemoScreen() {
  const [payload, setPayload] = useState(INITIAL_DATA);
  const [uploadMeta, setUploadMeta] = useState({ name: "", size: 0, ready: false });
  const [loading, setLoading] = useState(false);

  const payloadText = useMemo(() => JSON.stringify(payload, null, 2), [payload]);

  const handleFileUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (!/\.pdf$/i.test(file.name)) {
      Swal.fire("Invalid file", "Please upload a PDF file.", "warning");
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = String(reader.result || "");
      const base64 = dataUrl.includes(",") ? dataUrl.split(",")[1] : "";
      if (!base64) {
        Swal.fire("Error", "Could not convert file to base64.", "error");
        return;
      }
      setPayload((prev) => ({
        ...prev,
        data: {
          ...prev.data,
          identifiers: [
            {
              ...prev.data.identifiers[0],
              file_name: file.name,
              file_blob: base64,
              file_size: file.size,
            },
          ],
        },
      }));
      setUploadMeta({ name: file.name, size: file.size, ready: true });
      Swal.fire("File ready", "PDF converted to base64 and inserted in payload.", "success");
    };
    reader.onerror = () => Swal.fire("Error", "Failed to read file.", "error");
    reader.readAsDataURL(file);
  };

  const submitAddUcc = async () => {
    const id0 = payload?.data?.identifiers?.[0] || {};
    if (!id0.file_blob || !id0.file_name || !id0.file_size) {
      Swal.fire("Missing file", "Upload a PDF first so file_blob is filled.", "warning");
      return;
    }
    setLoading(true);
    try {
      const cleanedBlob = String(id0.file_blob || "")
        .replace(/^data:[^;]+;base64,/i, "")
        .replace(/\s+/g, "")
        .trim();
      const decodedSize = (() => {
        try {
          return atob(cleanedBlob).length;
        } catch (_e) {
          return Number(id0.file_size) || 0;
        }
      })();
      const submitPayload = {
        ...payload,
        data: {
          ...payload.data,
          identifiers: [
            {
              ...id0,
              identifier_type: "aof",
              file_name: "aof.pdf",
              file_blob: cleanedBlob,
              file_size: decodedSize,
            },
          ],
        },
      };

      const res = await submitMutualFundInvestorProfile(submitPayload);
      console.log(res);
      Swal.fire("Success", JSON.stringify(res.data, null, 2), "success");
    } catch (error) {
      console.log(error);
      const msg = JSON.stringify(
        {
          status: error?.response?.status,
          data: error?.response?.data || null,
          message: error?.message || "Request failed",
        },
        null,
        2
      );
      Swal.fire("BSE Error", msg, "error");
      console.error("Registration error:", error?.response?.status, error?.response?.data, error);
      
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          <div className="card">
            <div className="card-body">
              <h5 className="mb-3">Mutual fund registration (internal demo)</h5>
              <p className="text-muted mb-3">
                Upload a real PDF. This screen converts it for the server-side BSE registration flow.
              </p>

              <div className="mb-3">
                <label className="form-label">Upload AOF PDF</label>
                <input type="file" className="form-control" accept="application/pdf" onChange={handleFileUpload} />
                {uploadMeta.ready && (
                  <div className="form-text">
                    Selected: <strong>{uploadMeta.name}</strong> ({uploadMeta.size} bytes)
                  </div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">Request JSON</label>
                <textarea
                  className="form-control"
                  rows={14}
                  value={payloadText}
                  onChange={(e) => {
                    try {
                      const parsed = JSON.parse(e.target.value);
                      setPayload(parsed);
                    } catch (_) {
                      /* allow edit without forced parse each keypress */
                    }
                  }}
                />
              </div>

              <button className="btn btn-primary" onClick={submitAddUcc} disabled={loading}>
                {loading ? "Submitting..." : "Submit to BSE"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
